import { FanBadgeStatusEnum } from '@seaters/constants';
import { errorColor, successColor } from '@seaters/ui';

export interface FanBadgeStatusTagProps {
  status: FanBadgeStatusEnum;
}

const badgeStatusToColor = {
  [FanBadgeStatusEnum.REVOKED]: errorColor,
  [FanBadgeStatusEnum.AWARDED]: successColor,
};
export function FanBadgeStatusTag({ status }: FanBadgeStatusTagProps) {
  return (
    <span
      className="text-xs font-semibold uppercase tracking-wide"
      style={{ color: badgeStatusToColor[status] }}
    >
      {status}
    </span>
  );
}

export default FanBadgeStatusTag;
